// extracted by mini-css-extract-plugin
export default {"phoneCol":"SupplierEdit_phoneCol__XBSE9","timePicker":"SupplierEdit_timePicker__bFWxj"};